import auth from '@/router/auth'
import LuckyWheelIndex from '@/components/luckywheels/Index'
import LuckyWheelShow from '@/components/luckywheels/Show'

export default [
  {
    path: '/luckywheels',
    name: 'luckywheel-index',
    component: LuckyWheelIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/contacts/show/:course_id',
    name: 'contacts-show',
    component: LuckyWheelShow,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/luckywheels/router.js